if (!customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.addEventListener('click', (event) => {
        if (event.target === this) {
          this.close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });

      this.initTabs();
    }

    initTabs() {
      const tablist = this.querySelector('.size-guide-drawer__tabs');
      if (!tablist) return;

      tablist.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-size-guide-tab]');
        if (!tab || !tablist.contains(tab)) return;
        this.activateTab(tab.getAttribute('data-size-guide-tab'));
      });
    }

    activateTab(tabId) {
      const tabs = this.querySelectorAll('[data-size-guide-tab]');
      const panels = this.querySelectorAll('[data-size-guide-panel]');

      tabs.forEach((tab) => {
        const isActive = tab.getAttribute('data-size-guide-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-size-guide-panel') === tabId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    resetTabs() {
      this.activateTab('guide');
    }

    open() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflow = '';
      this.resetTabs();
      window.dosshaSizeFinder?.close();
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
}

window.openSizeGuideDrawer = function openSizeGuideDrawer() {
  const drawer = document.getElementById('SizeGuideDrawer');
  if (!drawer) return;

  if (typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
  document.documentElement.style.overflow = 'hidden';
};

window.closeSizeGuideDrawer = function closeSizeGuideDrawer() {
  const drawer = document.getElementById('SizeGuideDrawer');
  if (!drawer) return;

  if (typeof drawer.close === 'function') {
    drawer.close();
    return;
  }

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
  document.documentElement.style.overflow = '';
  window.dosshaSizeFinder?.close();
};
